<template>
    <FormItem :label="label" :required="required" :prop="fkey">
      <template v-if="editable">
      <Select
        :value="strValue"
        @input="handleInput"
        transfer
        clearable
        filterable
        :multiple="config.multiple"
        placeholder="请选择或输入文字"
        >
            <Option
            :label="o.name" v-for="o in options" :key="o.key" :value="o.key" :disabled="!editable"
            :border="config.border">
              <Icon v-if="o.icon" :type="o.icon"></Icon>
              <span>{{o.name}}</span>
          </Option>
      </Select>

      </template>
      <template v-else>
        <div>{{val_objects}}</div>
      </template>
   </FormItem>
  </template>

<script>
import composedMixin from '../mixins/composed';
import defaultValueMixin from '../mixins/default-value';
export default {
  mixins: [composedMixin, defaultValueMixin],
  cname: '下拉输入框',
  corder: 35,
  icon: 'xialaliebiao',
  properties: [{
    label: '选项',
    key: 'options',
    control: 'SelectOption',
  }, {
    label: '简易选项',
    key: 'simple',
    control: 'Check',
  },  {
    label: 'URL',
    key: 'url',
    control: 'Text',
  }],
  props: ['fkey', 'config', 'value', 'editable', 'label','required'],
  initModel(e) {
    if (!e.config) {
      e.config = {
        border: false,
        simple: true,
        options: [],
        url: '',
      };
    } else {
      e.config = {
        options: e.config.options || [],
        url: e.config.url,
        border: e.config.border,
        simple: e.config.simple,
        multiple: e.config.multiple,
      };
    }
  },
  data() {
    return {
      items: [],
    };
  },

  computed: {
    strValue() {
      if (this.multiple) {
        return Array.isArray(this.value)?this.value.map((v)=>v.toString()):[];
      } else {
        if (this.value !== undefined) {
          const value = this.value || 0;
          return value.toString();
        }
      }
    },
    val_objects() {
      if (this.multiple) {
        return Array.isArray(this.value)?
                this.value.map((v)=>this.options.find((t)=>t.key == this.value).name).join(','):'-';
      } else {
        return (this.options.find((t)=>t.key==this.value) || {}).name;
      }
    },
    options() {
      let options = this.config.options;
      if (Array.isArray(options)) {
        if (options && typeof options[0] != 'object') {
          options = options.map((v, i)=>({
            key: i,
            name: v,
          }));
        }
      }
      return options;
    },
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e);
    },

  },
};
</script>

  <style lang="less">
  .l-full{
    position: relative;
    height:100%;
    width:100%;
  }
  </style>
